import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { TabLink } from '../../../store/commonTypes'
import { Link } from '../../../i18next/helpers'

import './tabLinks.sass'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'

interface Props {
    links: TabLink[]
    archive?: boolean
}

const TabLinks: React.FunctionComponent<Props> = ({ links, archive = false }: Props) => {
    const location = useLocation()
    const [t] = useTranslation()
    const user = useSelector((state: RootState) => state.member.user)
    const getLastItemFromLink = (link: string) => link.split('/').reverse()[0]
    return (
        <div className="tabLinks">
            {links.map((link: TabLink) => {
                const className =
                    location.pathname.includes(link.path) &&
                    getLastItemFromLink(location.pathname) === getLastItemFromLink(link.path)
                        ? 'link link_active'
                        : 'link'
                return (
                    <Link className={className} to={link.path} key={link.label}>
                        {t(link.label)}
                        {link.amount > 0 ? ` (${link.amount})` : ''}
                    </Link>
                )
            })}
            {archive && user.counters.old_messages > 0 ? (
                <a className={'archive_link'} href={'/user/communication/inbox/'} target={'_blank'} rel="noreferrer">
                    {t('Archive')}
                </a>
            ) : (
                <></>
            )}
        </div>
    )
}

export default TabLinks
